export let ROLE_TYPES = [
  "Backend Developer",
  "Frontend Developer",
  "Full-Stack Developer",
  "Mobile Developer",
  "AI / ML Engineer",
  "Cloud Engineer",
  "DevOps Engineer",
  "Automation / Performance / Security Tester",
  "Infrastructure Engineer",
  "Cybersecurity Engineer",
  "ITSM Consultant",
  "ERP / Enterprise Applications – Technical",
  "ERP / Enterprise Applications – Functional",
  "Business Analyst",
  "UX / UI Designer",
  "Integration Engineer",
  "Database Engineer / DBA",
  "Specialized Engineering",
  "Documentation & Governance"
];

export let SENIORITIES = ['Junior',
  'Mid',
  'Senior',
  'Lead',
  'PM',
  'Account Manager',
  'CTO',
  'Solution Architect',
  'Enterprise Architect'];

export function setRoleTypes(list) {
  if (Array.isArray(list) && list.length) ROLE_TYPES = list;
}

export function setSeniorities(list) {
  if (Array.isArray(list) && list.length) SENIORITIES = list;
}

export const SCENARIO_DESCRIPTIONS = {
  A: 'Set up a new team. Ramp 3–9 months by size; senior core first, then build the team around it.',
  B: 'Enhance capacity of a running team. No ramp — only 3–6 week search & implementation.',
  C: 'Take over an existing department. Ramp + handover (+30–50%); the existing teams full cost stays in until BOT go-live, then ramps down (choose conservative or parallel).',
};

export const SCENARIO_DESCRIPTIONS_ROI = {
  A: 'New department. Ramp-up 3–9 months by team size. Start with senior experts who hold the knowledge, build and manage the team around them.',
  B: 'Add-on to an existing department to enhance capacity. No ramp-up — only a 3–6 week search & implementation phase. Fastest ROI.',
  C: 'Replace an existing department. The existing teams full cost stays in the model during transition, then ramps down — choose model A (after BOT go-live, conservative) or B (in parallel with the BOT build, realistic).',
};

export const ROLE_TYPE_ALIASES = {
  'Backend Developer': 'Backend Developer',
  'Frontend Developer': 'Frontend Developer',
  'Full-Stack Developer': 'Full-Stack Developer',
  'Mobile Developer': 'Mobile Developer',
  'AI / ML Engineer': 'AI / ML Engineer',
  'Cloud Engineer': 'Cloud Engineer',
  'DevOps Engineer': 'DevOps Engineer',
  'Automation / Performance / Security Tester': 'Automation / Performance / Security Tester',
  'Infrastructure Engineer': 'Infrastructure Engineer',
  'Cybersecurity Engineer': 'Cybersecurity Engineer',
  'ITSM Consultant': 'ITSM Consultant',
  'ERP / Enterprise Applications – Technical': 'ERP / Enterprise Applications – Technical',
  'ERP / Enterprise Applications – Functional': 'ERP / Enterprise Applications – Functional',
  'Business Analyst': 'Business Analyst',
  'UX / UI Designer': 'UX / UI Designer',
  'Integration Engineer': 'Integration Engineer',
  'Database Engineer / DBA': 'Database Engineer / DBA',
  'Specialized Engineering': 'Specialized Engineering',
  'Documentation & Governance': 'Documentation & Governance',
  '24x7 Support': '24x7 Support',
  'Support / Service Desk': 'Support / Service Desk',
  'Management': 'Management',
  'Technical Architect': 'Technical Architect',
};

export const GROSS_MID = {
  DE: {
    "Backend Developer": 121000,
    "Frontend Developer": 120000,
    "Full-Stack Developer": 120000,
    "Mobile Developer": 113000,
    "AI / ML Engineer": 137000,
    "Cloud Engineer": 128000,
    "DevOps Engineer": 131000,
    "Automation / Performance / Security Tester": 105000,
    "Infrastructure Engineer": 110000,
    "Cybersecurity Engineer": 130000,
    "ITSM Consultant": 120000,
    "ERP / Enterprise Applications – Technical": 125000,
    "ERP / Enterprise Applications – Functional": 115000,
    "Business Analyst": 116000,
    "UX / UI Designer": 120000,
    "Integration Engineer": 125000,
    "Database Engineer / DBA": 124000,
    "Specialized Engineering": 140000,
    "Documentation & Governance": 120000,
    "Support / Service Desk": 120000,
    "24x7 Support": 120000,
    "Management": 300000,
    "Technical Architect": 500000
  },
  CH: {
    "Backend Developer": 130000,
    "Frontend Developer": 128000,
    "Full-Stack Developer": 128000,
    "Mobile Developer": 120000,
    "AI / ML Engineer": 150000,
    "Cloud Engineer": 140000,
    "DevOps Engineer": 145000,
    "Automation / Performance / Security Tester": 120000,
    "Infrastructure Engineer": 125000,
    "Cybersecurity Engineer": 145000,
    "ITSM Consultant": 130000,
    "ERP / Enterprise Applications – Technical": 135000,
    "ERP / Enterprise Applications – Functional": 125000,
    "Business Analyst": 126000,
    "UX / UI Designer": 130000,
    "Integration Engineer": 135000,
    "Database Engineer / DBA": 134000,
    "Specialized Engineering": 150000,
    "Documentation & Governance": 130000,
    "Support / Service Desk": 130000,
    "24x7 Support": 130000,
    "Management": 320000,
    "Technical Architect": 550000
  },
};

export function getBenchmarkZone(region = 'DE') {
  // const code = String(region || 'DE').toUpperCase();
  // const europeCodes = new Set([
  //   'AL', 'AD', 'AM', 'AT', 'AZ', 'BY', 'BE', 'BA', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  //   'GE', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'KZ', 'XK', 'LV', 'LI', 'LT', 'LU', 'MT', 'MD', 'MC', 'ME',
  //   'NL', 'MK', 'NO', 'PL', 'PT', 'RO', 'RU', 'SM', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'TR', 'UA', 'GB', 'VA'
  // ]);
  // return europeCodes.has(code) ? 'EU' : 'IN';
  return 'EU';
}

export function getRegionBenchmark(region = 'DE') {
  const code = String(region || 'DE').toUpperCase();
  return GROSS_MID[code] || GROSS_MID.DE || {};
}

export function getRegionDisplayName(region = 'DE') {
  const code = String(region || 'DE').toUpperCase();
  const names = {
    DE: 'Germany',
    CH: 'Switzerland',
    US: 'United States',
    UK: 'United Kingdom',
    GB: 'United Kingdom',
    JP: 'Japan',
    AU: 'Australia',
    SC: 'Scotland',
  };
  return names[code] || code;
}

export const REGION_CURRENCY = {
  "DE": "Euro (EUR)",
  "CH": "Swiss Franc (CHF)",
  "US": "US Dollar (USD)"
};

export function getRegionCurrency(region = 'DE') {
  const code = String(region || 'DE').toUpperCase();
  const raw = REGION_CURRENCY[code] || 'EUR';
  // If mapped value includes a parenthesized ISO code like "Euro (EUR)", extract the 3-letter code
  const match = String(raw).match(/\(([A-Z]{3})\)/);
  if (match) return match[1];
  // If the raw value itself is a 3-letter code, return it
  if (/^[A-Z]{3}$/.test(String(raw))) return raw;
  // Fallback
  return 'EUR';
}

export function resolveBenchmarkRoleKey(roleType, benchmarkMap = GROSS_MID.DE) {
  const key = ROLE_TYPE_ALIASES[roleType] || roleType;
  if (!key) return key;
  if (benchmarkMap[key] !== undefined) return key;

  const normalizedInput = String(key).toLowerCase().replace(/[^a-z0-9]/g, '');
  const match = Object.keys(benchmarkMap).find((candidate) => {
    const normalizedCandidate = String(candidate).toLowerCase().replace(/[^a-z0-9]/g, '');
    return normalizedCandidate === normalizedInput
      || normalizedCandidate.includes(normalizedInput)
      || normalizedInput.includes(normalizedCandidate);
  });

  return match || key;
}

export const SMULT = {
  'Junior': 0.72,
  'Mid': 1.0,
  'Senior': 1.33,
  'Lead': 1.6,
  'PM': 1.75,
  'Account Manager': 1.9,
  'Solution Architect': 1.7,
  'Enterprise Architect': 1.95,
  'CTO': 2.05
};

// Static SpringUp rates by currency (fallback only — prefer master.json springUpRates)
// Values are already rounded; no runtime conversion.
export const SU_SEN = {
  EUR: {
    'Junior': 2200,
    'Mid': 2400,
    'Senior': 3600,
    'Lead': 4900,
    'PM': 4000,
    'Account Manager': 5300,
    'Solution Architect': 6600,
    'Enterprise Architect': 7900,
    'CTO': 7900,
    'DevOps/Cloud Support': 2400,
    'Application Support': 2400,
    'Support / Service Desk': 2400,
    '24x7 Support': 2400,
  },
  USD: {
    'Junior': 2500,
    'Mid': 2700,
    'Senior': 4100,
    'Lead': 5600,
    'PM': 4600,
    'Account Manager': 6100,
    'Solution Architect': 7600,
    'Enterprise Architect': 9100,
    'CTO': 9100,
    'DevOps/Cloud Support': 2700,
    'Application Support': 2700,
    'Support / Service Desk': 2700,
    '24x7 Support': 2700,
  },
  CHF: {
    'Junior': 2100,
    'Mid': 2200,
    'Senior': 3400,
    'Lead': 4600,
    'PM': 3700,
    'Account Manager': 5000,
    'Solution Architect': 6200,
    'Enterprise Architect': 7500,
    'CTO': 7500,
    'DevOps/Cloud Support': 2200,
    'Application Support': 2200,
    'Support / Service Desk': 2200,
    '24x7 Support': 2200,
  },
};

/** Resolve SpringUp rate for a seniority from static SU_SEN by currency */
export function getStaticSpringUpRate(seniority, currency = 'EUR') {
  const cur = String(currency || 'EUR').toUpperCase();
  const table = SU_SEN[cur] || SU_SEN.EUR;
  return table[seniority] ?? table['Mid'] ?? 2400;
}

export function formatCurrency(value, region = 'DE', overrideCurrency) {
  let currency = overrideCurrency || getRegionCurrency(region);
  // normalize when callers pass full-name strings like "Swiss Franc (CHF)"
  if (typeof currency === 'string') {
    const match = currency.match(/\(([A-Z]{3})\)/);
    if (match) currency = match[1];
    else if (/^[A-Z]{3}$/.test(currency)) currency = currency;
    else {
      const trailing = currency.match(/([A-Z]{3})$/);
      if (trailing) currency = trailing[1];
    }
  }
  if (!currency || !/^[A-Z]{3}$/.test(String(currency))) currency = 'EUR';

  const localeMap = {
    EUR: 'de-DE',
    USD: 'en-US',
    GBP: 'en-GB',
    JPY: 'ja-JP',
    AUD: 'en-AU',
    INR: 'en-IN',
  };
  const locale = localeMap[currency] || 'de-DE';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export function calculateRoi({
  region = 'DE',
  overhead = 25,
  roles = [],
  scenario = 'A',
  horizonMonths = 36,
  rampPercent = 55,
  setupFee = 150000,
  implementationWeeks = 4,
  handoverUplift = 0,
  legacyRampDownModel = 'A',
  legacyRampDownDuration = 3,
  currencyOverride,
  // conversionRates intentionally ignored — rates are static per region/currency in master.json
  conversionRates = {},
}) {
  // Static rates only — no FX conversion. Currency is determined by region (or override).
  const currency = currencyOverride || getRegionCurrency(region);

  const roleCosts = roles.map((role) => {
    const benchmarkMap = getRegionBenchmark(region);
    const normalizedRoleType = resolveBenchmarkRoleKey(role.roleType, benchmarkMap);
    const annual = (benchmarkMap[normalizedRoleType] || 0) * (SMULT[role.seniority] || 1);
    // Local benchmark still derived from gross salary + overhead (region-specific annuals)
    const benchmarkLocalRate = Math.round((annual * (1 + overhead / 100)) / 12 / 50) * 50;
    // SpringUp: use static per-currency table (master.json is preferred when available upstream)
    const benchmarkSpringUpRate = getStaticSpringUpRate(role.seniority, currency);

    const localRate = Number.isFinite(Number(role.localPerFte)) && Number(role.localPerFte) >= 0
      ? Number(role.localPerFte)
      : benchmarkLocalRate;
    const springUpRate = Number.isFinite(Number(role.springUpPerFte)) && Number(role.springUpPerFte) >= 0
      ? Number(role.springUpPerFte)
      : benchmarkSpringUpRate;

    return {
      ...role,
      localRate,
      springUpRate,
      localMonthly: Number(role.fte || 0) * localRate,
      springUpMonthly: Number(role.fte || 0) * springUpRate,
    };
  });

  const totalFte = roleCosts.reduce((sum, role) => sum + Number(role.fte || 0), 0);
  const localTotal = roleCosts.reduce((sum, role) => sum + role.localMonthly, 0);
  const springUpBase = roleCosts.reduce((sum, role) => sum + role.springUpMonthly, 0);
  const scenarioFactor = { A: 1, B: 0.92, C: 1.08 }[scenario] || 1;
  const rampFactor = 0.88 + (Number(rampPercent) / 100) * 0.2;
  const implementationFactor = scenario === 'B' ? 1 + Number(implementationWeeks) / 100 : 1;
  const handoverFactor = scenario === 'C' ? 1 + Number(handoverUplift) / 100 : 1;
  // monthly SpringUp recurring cost including amortized one-time setup fee over the selected horizon
  const amortizedSetupMonthly = Number(horizonMonths) > 0 ? Number(setupFee) / Number(horizonMonths) : 0;
  const springUpTotal = springUpBase * scenarioFactor * rampFactor * implementationFactor * handoverFactor + amortizedSetupMonthly;
  const savings = localTotal - springUpTotal;
  const savingsPct = localTotal > 0 ? (savings / localTotal) * 100 : 0;
  const totalLocalCost = localTotal * Number(horizonMonths);
  // total cost over horizon: monthly recurring (which already includes amortized setup) × months
  const totalSpringUpCost = springUpTotal * Number(horizonMonths);
  const netSavings = totalLocalCost - totalSpringUpCost;
  const roi = totalSpringUpCost > 0 ? (netSavings / totalSpringUpCost) * 100 : 0;
  const paybackMonths = savings > 0 ? Number(setupFee) / savings : 0;
  const effectiveRamp = Math.max(3, Math.min(9, Math.round(4 + (100 - rampPercent) / 20)));

  return {
    roleCosts,
    summary: {
      springUpBase,
      totalFte,
      teamSize: totalFte,
      localTotal,
      springUpTotal,
      totalLocalCost,
      totalSpringUpCost,
      savings,
      savingsPct,
      netSavings,
      roi,
      paybackMonths,
      rampBase: effectiveRamp,
      effectiveRamp,
    },
  };
}
